import { forwardRef } from "react";
import styleSheet from "./style.module.scss";
import { InputFormProps } from "./sy-input-interface";
import SyIcon from "../../components/sy-icon";
import SyTooltip from "../../components/sy-tooltip";

const SyInput = forwardRef<HTMLInputElement, InputFormProps>(
  (props: InputFormProps, ref) => {
    const {
      placeholder = "",
      type,
      onChange,
      inputType = "dark",
      handleFocus,
      className = "",
      size = "",
      inputHidden = false,
      value,
      iconStyle = "round",
      iconType = "symbols",
      withIcon = false,
      iconName = "near_me",
      selected,
      onClick,
      iconTip,
      ...rest
    } = props;

    const onClickIcon = () => {
      const inputElement = document.getElementById(
        "syInput"
      ) as HTMLInputElement;
      const inputData =
        inputElement && inputElement.value ? inputElement.value : null;
      onClick && onClick(inputData);
    };

    return (
      <div className=" position-relative w-100">
        {type === "textarea" ? (
          <textarea  id={withIcon ? "syInput" : void 0}
          placeholder={placeholder}
          onChange={onChange}
        
          value={value}
          onFocus={handleFocus}
          className={`   ${styleSheet.textAreaDark } mohave`}
          {...rest}
          rows={7}
          cols={50}>
            
          </textarea>
        ) : (
          <input
            id={withIcon ? "syInput" : void 0}
            ref={ref}
            placeholder={placeholder}
            onChange={onChange}
            autoComplete="new-password"
            value={value}
            type={type}
            onFocus={handleFocus}
            className={`${styleSheet[inputType]} ${
              selected ? styleSheet.selected : ""
            } ${className} ${styleSheet[size]}  ${
              inputType !== `hidden` && `mohave  `
            }  lh-1`}
            {...rest}
          />
        )}
        {withIcon && (
          <SyTooltip title={iconTip}>
            <span>
              <SyIcon
                className={
                  "position-absolute pointer end-0 top-50 translate-middle-y me-2"
                }
                iconStyle={iconStyle}
                iconType={iconType}
                name={iconName}
                iconColor="rgba(146, 143, 148, 1)"
                onClick={onClickIcon}
              />
            </span>
          </SyTooltip>
        )}
      </div>
    );
  }
);

export default SyInput;
